<template>
  <div style="min-width:1100px;">
    <a-tabs type="card">
      <a-tab-pane tab="基本信息" key="1">
        <a-form layout="inline">
          <div class="formtitle">
            <span>基本信息</span>
            <div>
              <a-button type="primary" size="small">重设密码</a-button>
              <a-button type="primary" size="small">获取身份证</a-button>
            </div>
          </div>
          <div class="formly">
            <div class="avatar">
              这里是个头像
            </div>
            <div class="formk">
              <a-form-item label="卡号">
                <a-input placeholder="请输入"></a-input>
              </a-form-item>
              <a-form-item label="卡类">
                <a-input></a-input>
              </a-form-item>
              <a-form-item>
                <span>卡类信息:前缀[BJK],最大长度[10]包含前缀</span>
              </a-form-item>
              <a-form-item label="姓名">
                <a-input placeholder="请输入"></a-input>
              </a-form-item>
              <a-form-item label="性别">
                <a-select
                  defaultValue="请选择"
                  style="width: 201px;margin-left:20px;"
                >
                  <a-select-option value="男">男</a-select-option>
                  <a-select-option value="女">女</a-select-option>
                </a-select>
              </a-form-item>
              <a-form-item> </a-form-item>
              <a-form-item label="业务员">
                <a-input placeholder="请输入"></a-input>
              </a-form-item>
              <a-form-item label="客户">
                <a-select
                  defaultValue="Tanaka"
                  style="width: 201px;margin-left:20px;"
                >
                  <a-select-option value="Tanaka">Tanaka</a-select-option>
                  <a-select-option value="KKro">KKro</a-select-option>
                  <a-select-option value="koi">koi</a-select-option>
                </a-select>
              </a-form-item>
              <a-form-item label="电话">
                <a-input placeholder="请输入"></a-input>
              </a-form-item>
            </div>
          </div>
          <div class="formtitle">
            <span>其他信息</span>
          </div>
          <div class="formly">
            <div class="avatar">
              这里是个签名
            </div>
            <div class="formk">
              <a-form-item label="证件类型">
                <a-select
                  defaultValue="身份证"
                  style="width: 201px;margin-left:20px;"
                >
                  <a-select-option value="身份证">身份证</a-select-option>
                  <a-select-option value="护照">护照</a-select-option>
                  <a-select-option value="军官证">军官证</a-select-option>
                </a-select>
              </a-form-item>
              <a-form-item label="证件号码">
                <a-input placeholder="请输入"></a-input>
              </a-form-item>
              <a-form-item label="生日">
                <a-input></a-input>
              </a-form-item>
              <a-form-item label="国籍">
                <a-input placeholder="请输入"></a-input>
              </a-form-item>
              <a-form-item label="籍贯">
                <a-input></a-input>
              </a-form-item>
              <a-form-item label="民族">
                <a-input></a-input>
              </a-form-item>
              <a-form-item label="会员备注" class="linegr">
                <a-input placeholder="请输入"></a-input>
              </a-form-item>
              <a-form-item label="客房备注" class="linegr">
                <a-input placeholder="请输入"></a-input>
              </a-form-item>
            </div>
          </div>
        </a-form>
      </a-tab-pane>
      <a-tab-pane tab="充值/消费" key="2">Content of Tab Pane 2</a-tab-pane>
      <a-tab-pane tab="积分兑换" key="3">Content of Tab Pane 3</a-tab-pane>
      <a-tab-pane tab="操作日志" key="4">Content of Tab Pane 3</a-tab-pane>
    </a-tabs>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  methods: {}
};
</script>
<style lang="less" scoped>
@size: 12px;
@color: rgb(214, 210, 210);
.formtitle {
  background: @color;
  div {
    float: right;
    line-height: 30px;
    button {
      margin-right: 10px;
      font-size: 12px;
    }
  }
  span {
    padding: 0 0 0 20px;
    line-height: 35px;
    font-size: @size;
  }
}
.formly {
  display: grid;
  grid-template-columns: 200px 1fr;
  .avatar {
    height: 150px;
  }
  .formk {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    input {
      margin-left: 20px;
      // width: 190px;
    }
    /deep/ .ant-form-item-label {
      width: 70px;
    }
    .linegr {
      grid-column-start: 1;
      grid-column-end: 4;
      /deep/ .ant-form-item-control-wrapper {
        width: 83.7%;
        input {
          width: 100%;
        }
      }
    }
  }
}
</style>
